import { UserNotificationOutcome, UserNotificationType } from '@shared/apis/notifications';

export type NotificationActionType = 'double-action' | 'link' | 'single-action';

export type NotificationCategory = 'general' | 'invite' | 'message';

export enum NotificationStatus {
  Actioned = 'actioned',
  Default = 'default',
  Error = 'error',
  Pending = 'pending',
}

export interface NotificationCta {
  label: string;
}

export interface NotificationItem {
  category: NotificationCategory;
  createdAt: string;
  cta?: NotificationCta;
  dismissible?: boolean;
  id: string;
  initialStatus?: NotificationStatus;
  link?: string;
  message: string;
  // The raw backend type, kept so a row can show the glyph for the thing it is about — a
  // stale disposal and a stale acquisition otherwise look the same.
  notificationType: UserNotificationType;
  // A third line below the message, muted, for the object the notification is about (e.g.
  // the property an invite relates to) — kept visually distinct from the sentence above it.
  subtext?: string;
  title: string;
  type: NotificationActionType;
  willFail?: boolean;
}

export interface ResolvedNotification extends NotificationItem {
  clearingInDays?: number;
  status: NotificationStatus;
}

export interface ResolvedNotificationHistoryItem extends NotificationItem {
  outcome: UserNotificationOutcome;
  outcomeLabel: string;
}
